<template>
  <div class="page-wrap" :style="{ height: viewportHeight }">
    <transition :name="step ? amimationList[step] : 'rotateUpLeft'">
      <FormBasic v-if="step === 'formBasic'" v-model="form" style="animation-duration: 0.6s"></FormBasic>
      <ShowGiftCard v-if="step === 'showGiftCard'" v-model="form" style="animation-duration: 0.6s"></ShowGiftCard>
      <Star v-if="step === 'star'" v-model="form" style="animation-duration: 0.6s"></Star>
      <EnsureEmail v-if="step === 'ensureEmail'" v-model="form" style="animation-duration: 0.6s"></EnsureEmail>
      <ChannelSelect v-if="step === 'channelSelect'" v-model="form" style="animation-duration: 0.6s"></ChannelSelect>
      <UploadPic v-if="step === 'uploadPic'" v-model="form" style="animation-duration: 0.6s"></UploadPic>
      <CityForm v-if="step === 'cityForm'" v-model="form" style="animation-duration: 0.6s"></CityForm>
      <PaypalForm v-if="step === 'paypalForm'" v-model="form" style="animation-duration: 0.6s"></PaypalForm>
      <DefaultPaypalForm v-if="step === 'defaultPaypalForm'" v-model="form" style="animation-duration: 0.6s"></DefaultPaypalForm>
      <ThanksAll v-if="step === 'thanksAll'" v-model="form" style="animation-duration: 0.6s"></ThanksAll>
      <Thanks v-if="step === 'thanks'" v-model="form" style="animation-duration: 0.6s"></Thanks>
    </transition>
    <van-overlay :show="loading" :custom-style="{ background: '#f0f0f0aa' }">
      <van-loading size="60px" color="#ffd814" />
    </van-overlay>
  </div>
</template>

<script>
import FormBasic from './components/formBasic.vue';
import ShowGiftCard from './components/showGiftCard.vue';
import Star from './components/star.vue';
import EnsureEmail from './components/ensureEmail.vue';
import ChannelSelect from './components/channelSelect.vue';
import UploadPic from './components/uploadPic.vue';
import CityForm from './components/cityForm.vue';
import PaypalForm from './components/paypalForm.vue';
import DefaultPaypalForm from './components/defaultPaypalForm.vue';
import ThanksAll from './components/thanks-all.vue';
import Thanks from './components/thanks.vue';
import { postUpdateStep,getViewer } from '@/api/portal';

export default {
  components: {
    FormBasic,
    ShowGiftCard,
    Star,
    EnsureEmail,
    ChannelSelect,
    UploadPic,
    CityForm,
    PaypalForm,
    ThanksAll,
    Thanks,
    DefaultPaypalForm
  },
  data() {
    return {
      step: '',
      viewportHeight: 0,
      loading: false,
      amimationList: {
        formBasic: 'rotateUpLeft',
        showGiftCard: 'rotateUpLeft',
        star: 'rotateUpLeft',
        ensureEmail: 'rotateUpLeft',
        channelSelect: 'rotateUpLeft',
        defaultPaypalForm:'rotateUpLeft',
        uploadPic: 'rotateUpLeft',
        cityForm: 'rotateUpLeft',
        paypalForm: 'rotateUpLeft',
        thanksAll: 'rotateUpLeft',
        thanks: 'rotateUpLeft',
      },
      form: {},
    };
  },
  mounted() {
    this.step = 'formBasic';
    this.viewportHeight = window.innerHeight + 'px';
    if (this.$store.getters.form) {
      this.form = this.$store.getters.form;
    }
    getViewer()
  },
  methods: {
    changeStep(step,data) {
      this.loading = true;
      if(data){
        postUpdateStep({current_step:step,order_id:this.form.order_id,data}).then(res => {
          setTimeout(_ => {
            this.loading = false;
            this.step = step;
          }, 2000);
        });
      }else{
        setTimeout(_ => {
          this.loading = false;
          this.step = step;
        }, 2000);
      }
    },
  },
};
</script>

<style>
.van-loading {
  width: 60px;
  height: 60px;
  top: calc(50% - 60px);
  margin: auto;
}
.page-wrap {
  width: 100%;
  height: 100vh;
  background-color: #5e5e5e;
  position: relative;
  .ant-form label {
    font-size: 16px;
    font-weight: 500;
  }
  .ant-input:focus {
    border: 1px solid #ffd814;
    box-shadow: none;
  }
  .ant-input:hover {
    border: 1px solid #ffd814;
    box-shadow: none;
  }
}
</style>
